export default function () {
    const $inputs = $('input:visible');
    if ($inputs.length) {
        $inputs.on('keyup focusout', function () {
            submitPasswordReset();
        });
    }
}

function submitPasswordReset() {
    const $passwordResetMsg = $('#passwordResetMsg');
    const $empNumValidMsg = $('#empNumValidMsg');
    const $empEmailValidMsg = $('#empEmailValidMsg');
    const $empNum = $('#empNum');
    const $empEmail = $('#empEmail');

    // reset submit message
    $passwordResetMsg.html('');

    // reset validation classes
    $empNum.removeClass('is-invalid');
    $empEmail.removeClass('is-invalid');

    // rehide validation messages
    $empNumValidMsg.addClass('hide');
    $empEmailValidMsg.addClass('hide');

    const empNum = $empNum.val();
    const email = $empEmail.val();

    const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

    if (empNum.length !== 6 || !email.match(emailRegex)) {
        // empNum or empEmail doesn't meet requirements
        if (empNum.length !== 6) {
            $empNumValidMsg.removeClass('hide');
            $empNum.addClass('is-invalid');
        }

        if (!email.match(emailRegex)) {
            $empEmailValidMsg.removeClass('hide');
            $empEmail.addClass('is-invalid');
        }

        $('#passReset').attr('disabled', true);
    } else {
        $('#passReset').attr('disabled', false);
    }
}
